import {
    FETCH_JURISDICTIONS,
    FETCH_JURISDICTIONS_FAIL,
    FETCH_JURISDICTIONS_SUCCESS,
    SET_JURISDICTION,
    SET_JURISDICTION_BY_CODE
} from './actionTypes';

export const setJurisdiction = args => ({
    type: SET_JURISDICTION,
    payload: args
});

export const setJurisdictionByCode = args => ({
    type: SET_JURISDICTION_BY_CODE,
    payload: args
});

/* keepSelection: read the list again without dropping the jurisdiction and brand that are selected (when they are still there). */
export const fetchJurisdictions = ({ keepSelection = false } = {}) => ({
    type: FETCH_JURISDICTIONS,
    payload: { keepSelection }
});

export const fetchJurisdictionsSuccess = response => ({
    type: FETCH_JURISDICTIONS_SUCCESS,
    payload: response
});

export const fetchJurisdictionsFail = error => ({
    type: FETCH_JURISDICTIONS_FAIL,
    payload: error
});
